import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  manufacturerSave,
  manufacturersLoadAll,
  productBuyersLoad,
  productClaimAccept,
  productSafetyDocumentDelete,
  productSafetyLoad,
  productSafetyUpdate,
  reportProductClaimsLoad,
  reportProductSafetyLoad,
  responsiblePersonSave,
  responsiblePersonsLoadAll,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(manufacturersLoadAll.type, send, socket);
  yield takeEvery(manufacturerSave.type, send, socket);
  yield takeEvery(responsiblePersonsLoadAll.type, send, socket);
  yield takeEvery(responsiblePersonSave.type, send, socket);
  yield takeEvery(productSafetyLoad.type, send, socket);
  yield takeEvery(productSafetyUpdate.type, send, socket);
  yield takeEvery(productSafetyDocumentDelete.type, send, socket);
  yield takeEvery(productBuyersLoad.type, send, socket);
  yield takeEvery(reportProductSafetyLoad.type, send, socket);
  yield takeEvery(reportProductClaimsLoad.type, send, socket);
  yield takeEvery(productClaimAccept.type, send, socket);
}
